<div class="empty-state-wrapper flex-vertical-center full-height ion-padding">
    <div *ngIf="iconName" class="empty-state-icon-wrapper">
        <lib-svg-icon
            color="var(--ion-color-primary)"
            backgroundColor="rgba(var(--ion-color-orange-rgb), 0.1)"
            [borderSpacing]="30"
            [roundBorder]="true"
            borderWidth="0px"
            [size]="35"
            [iconName]="iconName" />
    </div>
    <div>
        <h1 *ngIf="title" class="empty-state-title h2">{{ title }}</h1>
        <p *ngIf="description">{{ description }}</p>
    </div>
    <div class="empty-state-actions">
        <ng-content select="[content]"></ng-content>
        <div *ngIf="isLoggedIn && userType === 'client'">
            <ng-content *ngTemplateOutlet="loggedInClientActions"></ng-content>
        </div>
        <div *ngIf="!isLoggedIn">
            <ng-content *ngTemplateOutlet="loggedOutActions"></ng-content>
        </div>
    </div>
</div>

<ng-template #loggedOutActions>
    <div>
        <lib-button [routerLink]="registerPath">Create an account</lib-button>
    </div>
    <div>
        <lib-button [routerLink]="loginPath" borderStyle="none">Log in</lib-button>
    </div>
</ng-template>

<ng-template #loggedInClientActions>
    <lib-button [routerLink]="browsePath">Create a job</lib-button>
</ng-template>
